import PostList from './List';
import PostForm from './Form';

export default {
    path: 'cadastros',
    redirect: '/cadastros/post',
    name: 'Cadastro Post',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'post',
            name: 'list-post',
            component: PostList,
            meta: {
                requiresAuth: true,
                label: 'Listar Post'
            }
        },
        {
            path: 'post/novo',
            name: 'new-post',
            component: PostForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Post'
            }
        },
        {
            path: 'post/:id',
            name: 'edit-post',
            component: PostForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Post'
            }
        },
    ]
}



// WEBPACK FOOTER //
// ./src/views/post/router.js